module.exports = __webpack_public_path__ + "img/taoyuan-5.de0cc195.jpg";